<template>
  <div>
    <div class="container-fluid mt-3">
      <b-row>
        <!--     <b-col>
          <h4 class="ml-3">Categories</h4>
        </b-col> -->
      </b-row>
      <div class="">
        <TableBase
          :items="categories.data"
          :fields="fields"
          :options="options"
          :busy="categories.status === 'fetching' ? true : false"
        >
          <template v-slot:rightSide>
            <div>
              <!--   <b-button
                v-if="userHasPermission('categories', 'write')"
                variant="outline-yellow"
                class="align-bottom"
                @click="showModal()"
              >
                <b-icon icon="plus-circle" class="h4 m-1 align-bottom" />
                <span class="" />
              </b-button> -->
            </div>
          </template>
        </TableBase>
      </div>

      <b-modal
        id="detailsModal"
        ref="detailsModal"
        size="lg"
        hide-footer
        body-class="pl-0 pr-0"
        ok-disabled
        @hidden="categoryItem = {}"
      >
        <Brand />
        <UserForm
          :category-item="categoryItem"
          :refresh-data="getData"
          :hide-modal="hideModal"
        />
      </b-modal>
    </div>
  </div>
</template>
<script>
import TableBase from "@/modules/shared/table.vue";
import UserForm from "./Form";
import Brand from "@/modules/shared/brand.vue";

import { GET_CATEGORIES, POST_CATEGORY } from "./actions";
import { mapState } from "vuex";

import { generalMixin } from "@/modules/mixin.js";
import { superAdminMixin } from "../../../../superAdmin/mixins";
export default {
  components: { TableBase, UserForm, Brand },
  mixins: [generalMixin, superAdminMixin],
  computed: {
    ...mapState({
      categories: (state) => state.vehicle.workOrder.categories.categories,
    }),
    hasPermission() {
      return this.userHasPermission("categories", "write");
    },
    fields() {
      return [
        { key: "name", label: "Name" },

        { key: "topAmount", label: "Top amount" },

        {
          key: "actions",
          label: "Actions",
          note: false,
          details: true,
          validation: false,
          delete: this.hasPermission,
        },
      ];
    },
  },
  data() {
    return {
      options: {
        assign: false,
        rolFilter: false,
        add: false,
        fun: this.getData,
      },
      categoryItem: {},
    };
  },
  mounted() {
    this.$store.commit(
      "setAddFunction",
      this.userHasPermission("categories", "write") ? this.showModal : null
    );
    this.getData();
  },
  methods: {
    async getData(filter = "") {
      const payload = {
        search: filter,
      };
      this.$store
        .dispatch(GET_CATEGORIES, payload)
        .then(() => {})
        .catch(() => {
          this.$root.$bvToast.toast("error", {
            title: "Error",
            variant: "warning",
          });
        });
    },
    async deleteItem(item) {
      const confirm = await this.showConfirmDeleteBox();
      if (!confirm) return;
      const payload = {
        id: item.id,
        name: item.name,
        topAmount: item.topAmount,
        status: 1,
      };
      this.$store
        .dispatch(POST_CATEGORY, payload)
        .then(() => {
          this.getData();
        })
        .catch(() => {
          this.$root.$bvToast.toast("error", {
            title: "Error",
            variant: "warning",
          });
        });
    },
    async activateItem(item) {
      const payload = {
        id: item.id,
        name: item.name,
        topAmount: item.topAmount,
        status: 1,
      };
      this.$store
        .dispatch(POST_CATEGORY, payload)
        .then(() => {
          this.makeToast("Success", "Category updated successfully", "success");
          this.getData();
        })
        .catch(() => {
          this.$root.$bvToast.toast("Internal server error", {
            title: "Warning",
            variant: "warning",
          });
        });
    },
    showModal() {
      this.$bvModal.show("detailsModal");
    },
    editItem(item) {
      this.categoryItem = item;
      this.$bvModal.show("detailsModal");
    },
    changePage(page, filter = "") {
      const payload = {
        search: filter,
        page: page,
      };
      this.$store
        .dispatch(GET_CATEGORIES, payload)
        .then(() => {})
        .catch(() => {
          this.$root.$bvToast.toast("error", {
            title: "Error",
            variant: "warning",
          });
        });
    },

    hideModal() {
      this.$bvModal.hide("detailsModal");
    },
  },
};
</script>
